// src/pages/SalesVoucher/components/SalesOrderCorporateVoucher.jsx
import React, { useEffect, useState } from "react";
import { Card, Typography } from "antd";
import { getSalesOrderRecordWithDetailsApi } from "../../../../../apiservice/sales";

const { Title, Text } = Typography;

const SalesOrderCorporateVoucher = ({ sale_o_id, institution, authInfo, printMode = false }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sale_o_id) return;
    // Fixed: was salesRecordWithDetailsApi (Sales INVOICE endpoint) — queried
    // the wrong table entirely, so this component was blank for any sales
    // order not yet converted. Now the same Sales ORDER endpoint
    // SalesOrderVoucherBody already uses, which also returns approval_status
    // directly — no separate fetch needed for that anymore.
    getSalesOrderRecordWithDetailsApi({ sale_o_id, from: "voucher" })
      .then((res) => {
        if (res?.data?.length) {
          setData(res.data[0]);
        }
      })
      .catch((err) => console.error("Fetch corporate voucher failed", err));
  }, [sale_o_id]);

  if (!data) return null;

  // Same real-enforcement pattern as SalesOrderVoucherBody: this component
  // renders in printMode for both the hidden react-to-print layout (Print)
  // and the /print/sales-order/:id route the backend Puppeteer service
  // screenshots (Download) — blocking the render here blocks both.
  if (printMode && data.approval_status === "pending") {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <Title level={4}>Pending Approval</Title>
        <Text>This sales order is pending approval and cannot be downloaded or printed yet.</Text>
      </div>
    );
  }

  return (
    <Card
      className="shadow-md rounded-xl mt-4"
      bordered={!printMode}      
      styles={{
      body: { padding: printMode ? "0" : "16px" },
    }}
    >
      <Title level={5}>Corporate Sales Order Voucher</Title>
      <Text strong>Corporate Name: </Text> {data.corporate_name}
      <br />
      <Text strong>Voucher No: </Text> {data.sale_order_no}
      <br />
      <Text strong>Grand Total: </Text> {data.grand_total}
    </Card>
  );
};

export default SalesOrderCorporateVoucher;
